"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _classnames = _interopRequireDefault(require("classnames"));

var _logPropError = _interopRequireDefault(require("../../utils/logPropError"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var errorProps = [{
  prop: 'labelsClassName',
  replacement: 'labels.labelClassName'
}];

var SteppedProgressBar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SteppedProgressBar, _Component);

  var _super = _createSuper(SteppedProgressBar);

  function SteppedProgressBar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SteppedProgressBar);
    _this = _super.call(this, props);
    _this.state = {
      disableFollowingPages: props.disableFollowingPages ? props.disableFollowingPages : _this.props.selectedStepNumber,
      isValid: true
    };
    return _this;
  } // eslint-disable-next-line camelcase


  (0, _createClass2.default)(SteppedProgressBar, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.disableFollowingPages !== undefined) {
        if (nextProps.disableFollowingPages < nextProps.selectedStepNumber) {
          // eslint-disable-next-line no-console
          console.warn('Invalid component state detected in SteppedProgressBar: can not disable following ' + "pages ".concat(nextProps.disableFollowingPages, " when selectedStep is ").concat(nextProps.selectedStep, "!"));
          this.setState({
            isValid: false
          });
          return;
        }

        this.setState({
          disableFollowingPages: nextProps.disableFollowingPages
        });
      } else if (nextProps.selectedStepNumber > this.state.disableFollowingPages) {
        this.setState({
          disableFollowingPages: nextProps.selectedStepNumber
        });
      }
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(selectedKey) {
      this.props.onSelectedChanged(Number(selectedKey));
    }
  }, {
    key: "getItems",
    value: function getItems(labels) {
      var _this2 = this;

      return labels.map(function (labelObject, index) {
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav.Link, {
          eventKey: index,
          disabled: index > _this2.state.disableFollowingPages,
          as: 'a',
          key: index,
          className: (0, _classnames.default)('step-tab', labelObject.labelWrapperClassName)
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: 'step-tab-content'
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: 'item-icon'
        }, labelObject.icon), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('item-label', labelObject.labelClassName)
        }, labelObject.label)));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (!this.state.isValid) {
        return /*#__PURE__*/_react.default.createElement("b", null, "FIXME: INVALID STATE DETECTED!");
      }

      var _this$props = this.props,
          className = _this$props.className,
          variant = _this$props.variant,
          mobileBreakpoint = _this$props.mobileBreakpoint,
          selectedStepNumber = _this$props.selectedStepNumber;
      var wrapperClasses = (0, _classnames.default)('stepped-progress-bar', variant && "variant-".concat(variant), mobileBreakpoint && 'mobile-breakpoint', className && className);
      (0, _logPropError.default)(errorProps, this.props, 'SteppedProgressBar');
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav, {
        className: wrapperClasses,
        activeKey: selectedStepNumber,
        onSelect: function onSelect(selectedKey) {
          return _this3.handleSelect(selectedKey);
        }
      }, this.getItems(this.props.labels));
    }
  }]);
  return SteppedProgressBar;
}(_react.Component);

exports.default = SteppedProgressBar;
SteppedProgressBar.defaultProps = {
  selectedStepNumber: 1,
  labels: [],
  onSelectedChanged: function onSelectedChanged() {},
  variant: 'circle',
  mobileBreakpoint: true
};
SteppedProgressBar.propTypes = {
  disableFollowingPages: _propTypes.default.number,
  onSelectedChanged: _propTypes.default.func.isRequired,
  labels: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
    labelClassName: _propTypes.default.string,
    labelWrapperClassName: _propTypes.default.string
  })).isRequired,
  itemClassName: _propTypes.default.string,
  selectedStepNumber: _propTypes.default.number.isRequired,
  className: _propTypes.default.string,
  mobileBreakpoint: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(['circle', 'rectangle', 'roadsign'])
};